// Fallback AddToCart tracking for Meta Pixel.
//
// Why this exists: Shopify's built-in "product_added_to_cart" analytics event
// (the one Web Pixels / Customer Events listen for) only fires when the theme's
// own Ajax Cart flow runs. Cart-drawer apps like iCart handle add-to-cart with
// their own JavaScript, which can bypass that internal event entirely -- so no
// pixel (custom or third-party) ever sees an AddToCart, even though the cart
// really is being updated.
//
// Every Shopify cart implementation, no matter which app renders the drawer,
// still has to call the store's /cart/add endpoint to actually add the item
// (that's the only way to mutate a Shopify cart). So instead of relying on
// Shopify's internal event, this watches network requests directly for that
// endpoint and fires the Meta AddToCart pixel event from the response.
(function () {
  var PIXEL_ID = '2229105974522077';

  if (!window.fbq) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', PIXEL_ID);
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  function trackAddToCart(data) {
    if (!data) return;
    var items = data.items || [data];
    var contentIds = [];
    var value = 0;

    items.forEach(function (item) {
      if (item && item.product_id) {
        contentIds.push(String(item.product_id));
      }
      if (item && typeof item.line_price === 'number') {
        value += item.line_price;
      } else if (item && typeof item.final_line_price === 'number') {
        value += item.final_line_price;
      } else if (item && typeof item.price === 'number' && item.quantity) {
        value += item.price * item.quantity;
      }
    });

    if (contentIds.length === 0) return;

    fbq('track', 'AddToCart', {
      content_ids: contentIds,
      content_type: 'product',
      value: value / 100,
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    });
  }

  // Patch fetch() -- covers apps that add to cart via fetch('/cart/add.js', ...)
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var result = originalFetch.apply(this, arguments);
      if (isCartAddUrl(url)) {
        result
          .then(function (response) {
            response
              .clone()
              .json()
              .then(trackAddToCart)
              .catch(function () {});
          })
          .catch(function () {});
      }
      return result;
    };
  }

  // Patch XMLHttpRequest -- covers apps that add to cart via XHR instead of fetch
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartAddRequest = isCartAddUrl(url);
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartAddRequest) {
      this.addEventListener('load', function () {
        try {
          trackAddToCart(JSON.parse(this.responseText));
        } catch (e) {
          /* ignore parse errors */
        }
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
